import {jwtDecode} from "jwt-decode";

export const decodeToken = () => {
  try {
    const token = localStorage.getItem("token");
    return jwtDecode(token);
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
};
